
import * as d3 from "d3"; 
import { AXIS_LABEL_SIZE } from "../constants";

export default class D3_Utility{

    create_X_Scale(domain, rangeMin, rangeMax, paddingInner, paddingOuter){
        d3.scaleBand()
            .domain(domain) // Include gaps
            .range([rangeMin, rangeMax])
            .paddingInner(paddingInner)
            .paddingOuter(paddingOuter);
    }


    create_Y_Scale({minValue, maxValue, rangeMin, rangeMax}){
        return d3.scaleLinear()
            .domain([minValue, maxValue])
            .range([rangeMin, rangeMax]);
    }

    create_Y_Axis({svg, className, translateX, translateY, callInput, data, width, y1, y2, strokeColor, strokeWidth} ){
        svg.append("g")
            .attr("class", className)
            .attr("transform", `translate(${translateX}, ${translateY})`)
            .call(callInput)
            .selectAll("path, line, text")
            .style('font-size', AXIS_LABEL_SIZE)
            .style("stroke", "none");

        svg.append("g")
            .selectAll("line")
            .data(data)
            .join("line")
            .attr('class', `${className}-line`)
            .attr("x1", translateX)
            .attr("x2", width)
            .attr("y1", y1)
            .attr("y2", y2)
            .attr("stroke", strokeColor)
            .attr("stroke-dasharray", "2,2")
            .attr("stroke-width", strokeWidth);
    }


    drawBars(){

    }
}